import { render, staticRenderFns } from "./ChoixRisque.vue?vue&type=template&id=083a8438&scoped=true&"
import script from "./ChoixRisque.vue?vue&type=script&lang=js&"
export * from "./ChoixRisque.vue?vue&type=script&lang=js&"
import style0 from "./ChoixRisque.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ChoixRisque.vue?vue&type=style&index=1&id=083a8438&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083a8438",
  null
  
)

export default component.exports